import { NotificationBar } from "@similarweb/ui-components";
import type * as React from "react";
import { Component } from "react";
import { connect } from "react-redux";

interface INotificationItem {
    id: string;
    text?: string;
    customComponent?: any;
    onClose?: () => {};
}

interface INotificationBarContainer {
    pageNotificationList: [INotificationItem];
}

class PageNotificationBarContainerComponent extends Component<INotificationBarContainer, any> {
    protected containerDiv;

    constructor(props) {
        super(props);
    }

    public render() {
        return (
            <div
                ref={(div) => {
                    this.containerDiv = div;
                }}
            >
                {this.props.pageNotificationList
                    ? this.props.pageNotificationList.map((notification) => {
                          const CustomComponent = notification.customComponent;
                          return CustomComponent ? (
                              <CustomComponent
                                  key={notification.id}
                                  {...notification}
                              />
                          ) : (
                              <NotificationBar
                                  key={notification.id}
                                  onClose={notification.onClose}
                              >
                                  {notification.text}
                              </NotificationBar>
                          );
                      })
                    : null}
            </div>
        );
    }
}

function mapStateToProps({ common }) {
    const pageNotificationList = common.pageNotificationList;
    return {
        pageNotificationList,
    };
}

export const PageNotificationBarContainer = connect(
    mapStateToProps,
    undefined,
)(PageNotificationBarContainerComponent as React.ComponentType<any>);
